import { render, staticRenderFns } from "./HdsCard.vue?vue&type=template&id=422933ed&scoped=true&"
import script from "./HdsCard.vue?vue&type=script&lang=ts&"
export * from "./HdsCard.vue?vue&type=script&lang=ts&"
import style0 from "./HdsCard.vue?vue&type=style&index=0&id=422933ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422933ed",
  null
  
)

export default component.exports